import { render, staticRenderFns } from "./PayGoOnboardingModal.vue?vue&type=template&id=ffc3065c"
import script from "./PayGoOnboardingModal.vue?vue&type=script&lang=js"
export * from "./PayGoOnboardingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports